import Axios, { AxiosRequestConfig, InternalAxiosRequestConfig } from 'axios';
import { getLocalParameters } from 'src/helpers/AppCode';


function getToken(): string {
  const data = JSON.parse(localStorage.getItem(`${process.env.REACT_APP_BASENAME}_authUser`) || '{}');
  return data.token || "";
}

const getDefaultApiUrl = async (): Promise<string> => {
  let localParameters: LocalParameters | null = await getLocalParameters();
 
  return localParameters ? `${localParameters.defaultApiUrl}/` : "ProblemWithLocalParameters";
}

function authRequestInterceptor(config: InternalAxiosRequestConfig ): InternalAxiosRequestConfig  {
  const token: string = getToken();
  if(config.headers){
    config.headers.Authorization = `Bearer ${token}`;
    config.headers.Accept = 'application/json';
  }
    
  return config;
}

export const axiosDefaultApi = Axios.create();

(async () => {
  const url = await getDefaultApiUrl();
  axiosDefaultApi.defaults.baseURL = url;
})();

export const axiosSelfApi = Axios.create({
  baseURL: `/${process.env.REACT_APP_BASENAME}/`,
});

axiosDefaultApi.interceptors.request.use(authRequestInterceptor);
//axiosSelfApi.interceptors.request.use();

axiosDefaultApi.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    const message = error.response?.data?.message || error.message;
    /*useNotificationStore.getState().addNotification({
      type: 'error',
      title: 'Error',
      message,
    });*/
    //console.log("Error", message, "Code", error.message)
    if(error.response && error.response.status == 401){
      const defaultBasename = process.env.REACT_APP_BASENAME;
        
      window.location.pathname = `/${defaultBasename}/logout`;
    }

    return Promise.reject(error);
  }
);

axiosSelfApi.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    const message = error.response?.data?.message || error.message;
    /*useNotificationStore.getState().addNotification({
      type: 'error',
      title: 'Error',
      message,
    });*/
    console.log("Error", message, "Code", error.response)
    if(error.response.status == 401){
      const defaultBasename = process.env.REACT_APP_BASENAME;
        
      window.location.pathname = `/${defaultBasename}/logout`;
    }

    return Promise.reject(error);
  }
);
